
// import Notice from "~/components/home/notice.vue";
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
import { parseTime } from "~/utils/index.js";
export default {
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      searchValue: '',
      addressValue: '',
      workList: [
        {
          title: this.$t('joinUs.job1.mainHeadline'),
          time: parseTime(new Date(), '{y}-{m}-{d}'),
          path: '/aboutUs/001',
        },
        {
          title: this.$t('joinUs.job2.mainHeadline'),
          time: parseTime(new Date(), '{y}-{m}-{d}'),
          path: '/aboutUs/002',
        },
        {
          title: this.$t('joinUs.job3.mainHeadline'),
          time: parseTime(new Date(), '{y}-{m}-{d}'),
          path: '/aboutUs/003',
        },
      ],
    }
  },
  computed: {
    timeList() {
      return this.$t('joinUs.timeList');
    },
    addressList() {
      return this.$t('joinUs.addressList');
    },
    contentList() {
      let data = this.$t('aboutUs.contentList');
      return data;
    },
    selectionWorkList() {
      if (this.addressValue == '深圳市' || this.addressValue == 'Shenzhen') {
        return [];
      } 
      const workList = this.workList;
      if (this.searchValue == '') {
        return workList;
      }
      let data = workList.filter((item) => {
        if (item.title.indexOf(this.searchValue) > -1) {
          return item;
        }
      });
      return data;
    },
  },
  methods: {
    selection(item) {
      this.addressValue = item.name;
    }
  }
}
